<template>
  <Head title="Login" />
  <div class="flex items-center justify-center p-6 min-h-screen bg-orfBlue-800 relative">
    <flash-messages/>
    <div class="w-full max-w-sm">
      <img class="mx-auto" src="/img/Enterprise_quer_4C_HG%20blau.png" width="120" />
      <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="login">
        <div class="px-10 py-8">
          <h1 class="text-center text-3xl font-bold">Office Tool</h1>
          <div class="mt-6 mx-auto w-24 border-b-2" />
          <text-input v-model="form.email" :error="form.errors.email" class="mt-10" label="Email" type="email" autofocus autocapitalize="off" />
          <text-input v-model="form.password" :error="form.errors.password" class="mt-6" label="Password" type="password" />
          <label class="flex items-center mt-6 select-none" for="remember">
            <input id="remember" v-model="form.remember" class="mr-1" type="checkbox" />
            <span class="text-sm">Angemeldet bleiben</span>
          </label>
          <tooltip class="hover:underline cursor-pointer text-sm float-right" text="Kontaktiere deine/n Abteilungsleiter/in!">
              Passwort vergessen?
          </tooltip>
        </div>
        <div class="flex justify-center px-10 py-4 bg-gray-100 border-t border-gray-100">
          <loading-button :loading="form.processing" text="Login" class="h-12 w-24"/>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import FlashMessages from '@/Shared/FlashMessages.vue'
import Tooltip from "@/Shared/Tooltip.vue";

export default {
  components: {
      Tooltip,
    FlashMessages,
    Head,
    LoadingButton,
    Logo,
    TextInput,
  },
  data() {
    return {
      form: this.$inertia.form({
        email: '',
        password: '',
        remember: false,
      }),
    }
  },
  methods: {
    login() {
      this.form.post('/login')
    },
  },
}
</script>
